export const SUB_SUB_MENU_TYPE_REQUEST = 'SUB_SUB_MENU_TYPE_REQUEST';
export const SUB_SUB_MENU_TYPE_SUCCESS = 'SUB_SUB_MENU_TYPE_SUCCESS';
export const SUB_SUB_MENU_TYPE_FAIL = 'SUB_SUB_MENU_TYPE_FAIL';

